var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import { InputText } from "primereact/inputtext";
import * as React from 'react';
import { withRouter } from "react-router-dom";
import ApiRequests from "../../../classes/http/ApiRequests";
import HttpRequests from "../../../classes/http/HttpRequests";
import Grid from '../../../components/UI/Grid/Grid';
var UsersList = /** @class */ (function (_super) {
    __extends(UsersList, _super);
    function UsersList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.gridHeaders = [
            { name: 'Email', key: 'email', filter: false, sort: false },
            { name: 'Админ', key: 'is_admin', formatter: 'boolean', filter: false, sort: false },
            { name: 'Потвърден', key: 'is_confirmed', formatter: 'boolean', filter: false, sort: false },
        ];
        // public editUser = (rowItem: any): void => {
        //     const selectedId: string = _.get(rowItem, 'id', '0');
        //     if (selectedId !== '0') {
        //         this.props.history.push(AppRoutes.editUser.path.replace(':id', selectedId));
        //     }
        // }
        _this.deleteUser = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            var ask = confirm("\u041D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u0438 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B \u0441 email " + _.get(rowItem, 'email', 'Неналично име'));
            if (ask) {
                _this.api.deleteUser(selectedId)
                    .then(function (response) {
                    // Delete the item from the state of the parent component
                    _this.props.deleteItem(selectedId);
                })
                    .catch(function (error) {
                    _this.http.handleError(error, _this.props.messages, 'Потребителят не бе изтрит. Моля, опитайте отново.', _this.props.history);
                });
            }
        };
        _this.onPage = function (event) {
            _this.props.changePage(event.page + 1);
        };
        return _this;
    }
    UsersList.prototype.render = function () {
        var _a = this.props, gridData = _a.gridData, meta = _a.meta, search = _a.search;
        var header = (React.createElement("div", { style: { 'textAlign': 'left' } },
            React.createElement("i", { className: "pi pi-search", style: { margin: '4px 4px 0 0' } }),
            React.createElement(InputText, { type: "search", onInput: search, placeholder: "\u0422\u044A\u0440\u0441\u0435\u043D\u0435 \u043F\u043E Email" })));
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: '', paginator: true, total: _.get(meta, 'total_records', 0), rows: _.get(meta, 'per_page', 0), first: (_.get(meta, 'current_page', 0) - 1) * _.get(meta, 'per_page', 0), deleteAction: this.deleteUser, onPage: this.onPage, lazy: true, header: header }));
    };
    return UsersList;
}(React.Component));
// @ts-ignore
export default withRouter(UsersList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Users/UsersList/UsersList.tsx
// module id = 495
// module chunks = 0